import { connect } from 'react-redux';
import Love from './Love';
import { getLoveCount } from '../../../../../LoveMeter/redux/selectors';
var mapStateToProps = function (state, _a) {
    var _b = _a.deviation, deviationId = _b.deviationId, stats = _b.stats, loveScore = _b.loveScore;
    return {
        loveCount: getLoveCount(state, deviationId, {
            loveScore: loveScore,
            loveCount: stats && stats.loveLevel,
        }),
    };
};
export default connect(mapStateToProps)(Love);
//# sourceMappingURL=Love.container.js.map